'use strict';

module.exports = require('./_iterate')('forEach');



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/object/for-each.js
// module id = 574
// module chunks = 4